// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3Jjr3","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3it3w","obliqueLine":"membershipbadge_obliqueLine__2smTY"};